import React, { useState, useEffect, useRef }  from 'react';

import { IoMdClose } from 'react-icons/io';
import { CgMenuRight } from 'react-icons/cg';

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const menuVariants = {
  hidden: {
    x: '100%',
  },
  visible: {
    x: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9],
    },
  },
}
const MobileNav = () => {

  const navigationMenu = [
    { name: 'Home', path: '/', ref: useRef(null) },
    { name: 'About', path: '/about', ref: useRef(null) },
    { name: 'Projects', path: '/projects', ref: useRef(null) },
    { name: 'Contact', path: '/contact', ref: useRef(null) },
  ];

  const [menuLinks, setMenuLinks] = useState (navigationMenu);
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    if (openMenu) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [openMenu]);

  const closeMenu = () => {
    setOpenMenu(false);
  };

  return (
    <nav className='md:hidden'>
      <div
      onClick={() => setOpenMenu(true)}
      className='text-3xl text-secondary cursor-pointer
      '>
        <CgMenuRight />
      </div>
      <motion.div
        variants={menuVariants}
        initial='hidden'
        animate={openMenu ? 'visible' : ''}
        className='
          absolute z-20
          top-0 right-0
          h-screen
          w-full
          shadow-2xl
            bg-secondary
        '
        style={{ fontFamily: 'Ledger, serif' }}
        >
        <div
        onClick={() => setOpenMenu(false)}
        className='
          flex
          justify-end
          w-full
          p-4
          text-xl text-primary
          cursor-pointer
        '>
          <IoMdClose size={30}/>
        </div>
        <div className='
          flex flex-col
          items-center justify-center
          h-[80vh]
          gap-y-12
          text-3xl text-primary
          font-bold
        '>
        <ul className='flex flex-col items-center justify-center gap-y-12
        '>
          {menuLinks && menuLinks.length ? menuLinks.map((menuLink, index) => (
            <Link
            to= {menuLink.path}
            key={index}
            onClick={closeMenu }
            className='hover:underline'>
              {menuLink.name}
            </Link>
          ))
        : null
        }
        </ul>
        </div>
      </motion.div>
    </nav>
  );
};

export default MobileNav;